export const sleepAssessmentConstant = {
    GET_PENDING_BY_PERSON_SUCCESS: 'SLEEP_ASSESSMENT_GET_PENDING_BY_PERSON_SUCCESS',
    OPEN_DIALOG: 'SLEEP_ASSESSMENT_OPEN_DIALOG',
    CLOSE_DIALOG: 'SLEEP_ASSESSMENT_CLOSE_DIALOG',
    REFUND_SUCCESS: 'SLEEP_ASSESSMENT_REFUND_SUCCESS',
    GO_TO_SLEEPASSESSMENT:'SLEEP_ASSESSMENT_GO_TO_SLEEPASSESSMENT',
    SET_OPEN_PENDING_SLEEP: 'SET_OPEN_PENDING_SLEEP'
};
